module.exports = __webpack_public_path__ + "static/media/icons.df45b7de.woff";